import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ssApiService } from 'app/services/ss-api.service';
import { UnlockLoginRequest } from 'app/models/ss-api/requests/unlock.code.request';

@Component({
    selector: 'unlock-login',
    templateUrl: './unlock-login.component.html',
    styleUrls: ['./unlock-login.component.scss']
})
export class UnlockLoginComponent implements OnInit, OnDestroy {

    IsBusy: boolean = false;


    // ID's FROM ROUTE PARAMTERS
    routeParams: object;
    UnlockCode: string;

    // DATA SUBSCRIPTION VARIABLES
    paramsSubscribe: any;

    Title: string = 'trying to unlock';
    SubTitle: string = 'please wait ...';

    constructor(private route: ActivatedRoute, private api: ssApiService, private router: Router) {
        this.paramsSubscribe = this.route.params.subscribe(params => this.routeParams = params);
    }

    async ngOnInit() {


        // get param
        this.UnlockCode = this.routeParams['unlockCode'];

        // check param
        if (this.UnlockCode == undefined)
            window.location.href = 'http://www.structurestudios.com';

        // try tounlock
        await this.Unlock();
    }

    ngOnDestroy() {
        this.paramsSubscribe.unsubscribe();
    }


    async Unlock() {

        let request = new UnlockLoginRequest();
        request.Code = this.UnlockCode;

        await this.api.UnlockLogin(request).toPromise()
            .then((result) => {

                if (result.Result)
                    this.Redirect();

                else
                    window.location.href = 'http://www.structurestudios.com';

            })
            .catch((error) => {
                window.location.href = 'http://www.structurestudios.com';
            });

    }


    Redirect() {

        this.Title = 'UNLOCKED!';
        this.SubTitle = 'Redirecting to login ...';

        setTimeout(() => {
            this.router.navigate(['authentication/signin']);
        }, 3000);

    }


}
